import { getUserById } from "../api/getUserById";
import { createUserData } from "../api/createUserData";
import { pushNickname } from "../api/pushNickname";
import dotenv from "dotenv";

dotenv.config();

// Initialize Realm app with your App ID
const app = new Realm.App({ id: `${process.env.REALM_WEB_ID}` });

async function loginEmailPassword(email, password) {
  const credentials = Realm.Credentials.emailPassword(email, password);

  try {
    // Authenticate the user
    const user = await app.logIn(credentials);

    // `App.currentUser` updates to match the logged in user
    console.assert(user.id === app.currentUser.id);
    const result = await getUserById(app.currentUser.id);
    if (!result.success) {
      window.localStorage.clear();
      setError(result.data);
      buttonPrisijungti();
      return;
    }
    if (result.data === null || result.data.nickname === undefined) {
      if (result.data === null) {
        const result = await createUserData(app.currentUser.id);
        if (!result.success) {
          setError(result.data);
          window.localStorage.clear();
          buttonPrisijungti();
          return;
        }
      }
      document.getElementById("authForm").remove();

      const authorization = document.querySelector(".authorization");
      const form = document.createElement("form");
      form.id = "authForm";
      authorization.appendChild(form);

      const blank = document.createElement("div");
      blank.classList = "auth__background";
      form.appendChild(blank);

      const formTitle = document.createElement("h1");
      formTitle.textContent = "Slapyvardis:";
      formTitle.classList = "auth__title";
      blank.appendChild(formTitle);

      const nicknameInput = document.createElement("input");
      nicknameInput.type = "text";
      nicknameInput.name = "nickname";
      nicknameInput.id = "nickname";
      nicknameInput.required = true;
      form.appendChild(nicknameInput);

      const allerts = document.createElement("div");
      allerts.id = "allerts";
      allerts.style.height = "50px";
      form.appendChild(allerts);

      const submitButton = document.createElement("button");
      submitButton.textContent = "sukurti";
      submitButton.classList = "buttonNickname";
      form.appendChild(submitButton);

      submitButton.addEventListener("click", async (e) => {
        e.preventDefault();
        submitButton.disabled = true;
        const nicknameValue = nicknameInput.value.trim();
        if (nicknameValue === "") {
          setError("Slapyvardis neįvestas.");
          submitButton.disabled = false;
          return;
        }
        const result = await pushNickname(
          nicknameInput.value,
          app.currentUser.id
        );
        if (!result.success) {
          setError(result.data);
          submitButton.disabled = false;
          return;
        }
        window.location.assign("/");
      });
    } else {
      window.location.assign("/");
    }
    return user;
  } catch (err) {
    buttonPrisijungti();
    setError("Netinkamas el. paštas / slaptažodis.");
  }
}

function setError(errorMessage) {
  clearErrors();
  document.getElementById("allerts").classList = "errorAllerts";
  const error = document.createElement("div");
  error.classList.add("error-message");
  error.textContent = errorMessage;
  document.getElementById("allerts").appendChild(error);
}

function clearErrors() {
  const inputs = document.querySelectorAll("input");
  inputs.forEach((input) => {
    input.classList.remove("error");
    const error = input.parentNode.querySelector(".error-message");
    if (error) {
      error.remove();
    }
  });
  allerts.removeAttribute("class");
}

// Function to handle form login
export async function loginUser() {
  const email = document.getElementById("email").value;
  const password = document.getElementById("password").value;

  await loginEmailPassword(email, password);
}

function buttonPrisijungti() {
  const submitButton = document.getElementById("auth");
  submitButton.textContent = "prisijungti";
  submitButton.textContent = submitButton.textContent.toUpperCase();
  document.getElementById("auth").disabled = false;
}
